/** Computer-use action labels (tests/fixtures/activity-labels/desktop.json). English equals the fixture exactly. */
export default {
  "desktop.quoted": "“{name}”",
  "desktop.in_app": "{action} in {app}",
  "desktop.approved": "{action} (approved)",
  "desktop.opening_tab_named": "Opening the {name} tab",
  "desktop.opening_page": "Opening a page",
  "desktop.opening_link": "Opening link",
  "desktop.revealing_file": "Revealing file",
  "desktop.opening_named": "Opening {name}",
  "desktop.opening_file": "Opening file",
  "desktop.opening_app": "Opening app",
  "desktop.switching_tab_named": "Switching to the {name} tab",
  "desktop.switching_tab": "Switching browser tab",
  "desktop.closing_tabs": {
    one: "Closing a tab",
    other: "Closing {count} tabs",
  },
  "desktop.window_named": "the {app} window",
  "desktop.window": "the window",
  "desktop.focusing_named": "Focusing {app}",
  "desktop.focusing_window": "Focusing the window",
  "desktop.moving_window_to_screen": "Moving {window} to another screen",
  "desktop.resizing_window": "Resizing {window}",
  "desktop.managing_window": "Managing window",
  "desktop.maximizing_window": "Maximizing {window}",
  "desktop.centering_window": "Centering {window}",
  "desktop.moving_window_to": "Moving {window} to the {place}",
  "desktop.arranging_window": "Arranging {window}",
  "desktop.place.left_half": "left half",
  "desktop.place.right_half": "right half",
  "desktop.place.left_side_panel": "left side panel",
  "desktop.place.right_side_panel": "right side panel",
  "desktop.place.top_half": "top half",
  "desktop.place.bottom_half": "bottom half",
  "desktop.place.top_left_quadrant": "top left quadrant",
  "desktop.place.top_right_quadrant": "top right quadrant",
  "desktop.place.bottom_left_quadrant": "bottom left quadrant",
  "desktop.place.bottom_right_quadrant": "bottom right quadrant",
  "desktop.playing_track": "Playing a track",
  "desktop.resuming_playback": "Resuming playback",
  "desktop.turning_shuffle_on": "Turning shuffle on",
  "desktop.turning_shuffle_off": "Turning shuffle off",
  "desktop.turning_repeat_on": "Turning repeat on",
  "desktop.turning_repeat_off": "Turning repeat off",
  "desktop.setting_shuffle": "Setting shuffle",
  "desktop.setting_repeat": "Setting repeat",
  "desktop.checking_playing": "Checking what's playing",
  "desktop.pausing": "Pausing",
  "desktop.playing_or_pausing": "Playing or pausing",
  "desktop.playing_next_track": "Playing next track",
  "desktop.playing_previous_track": "Playing previous track",
  "desktop.seeking": "Seeking in the track",
  "desktop.setting_volume": "Setting volume",
  "desktop.controlling_playback": "Controlling playback",
  "desktop.app_action_named": "{app}: {action}",
  "desktop.using_app": "Using {app}",
  "desktop.unnamed_app": "App",
  "desktop.reading_page": "Reading the page",
  "desktop.reading_text": "Reading the text",
  "desktop.looking_at_page": "Looking at the page",
  "desktop.finding_control": "Finding control",
  "desktop.reading_controls_named": "Reading {app}'s controls",
  "desktop.reading_app_controls": "Reading app controls",
  "desktop.getting_screens": "Getting screens",
  "desktop.getting_windows": "Getting windows",
  "desktop.getting_cursor": "Getting cursor",
  "desktop.checking_focused_window": "Checking focused window",
  "desktop.checking_working_window": "Checking working window",
  "desktop.reading_browser_tabs": "Reading browser tabs",
  "desktop.checking_permissions": "Checking permissions",
  "desktop.checking_desktop": "Checking desktop",
  "desktop.reading_selection": "Reading the selection",
  "desktop.reading_menu_commands": "Reading menu commands",
  "desktop.searching_files_named": "Searching files: {query}",
  "desktop.searching_files": "Searching files",
  "desktop.finding_apps": "Finding apps",
  "desktop.screenshot_area": "Taking screenshot of a {size} area",
  "desktop.looking_at_denker": "Looking at Denker",
  "desktop.looking_at_named": "Looking at {app}",
  "desktop.looking_at_screen": "Looking at the screen",
  "desktop.reading_app": "Reading app",
  "desktop.opening_browser_tab": "Opening browser tab",
  "desktop.finding_file": "Finding file",
  "desktop.finding_file_named": "Finding file {query}",
  "desktop.pressing_control": "Pressing control",
  "desktop.opening_menu": "Opening menu",
  "desktop.typing_text": "Typing text",
  "desktop.setting_value": "Setting value",
  "desktop.pressing_key": "Pressing key",
  "desktop.waiting_for_app": "Waiting for app",
  "desktop.app_action": "App action",
  "desktop.controlling_app": "Controlling app",
  "desktop.guiding_on_screen": "Guiding on screen",
  "desktop.pressing_named": "Pressing {target}",
  "desktop.opening_menu_named": "Opening menu {target}",
  "desktop.typing_into_named": "Typing into {target}",
  "desktop.setting_named": "Setting {target}",
  "desktop.clicking": "Clicking",
  "desktop.clicking_named": "Clicking {target}",
  "desktop.double_clicking": "Double-clicking",
  "desktop.double_clicking_named": "Double-clicking {target}",
  "desktop.right_clicking": "Right-clicking",
  "desktop.right_clicking_named": "Right-clicking {target}",
  "desktop.double_right_clicking": "Double right-clicking",
  "desktop.double_right_clicking_named": "Double right-clicking {target}",
  "desktop.pointing": "Pointing",
  "desktop.pasting_text": "Pasting text",
  "desktop.dragging": "Dragging",
  "desktop.scrolling": "Scrolling",
  "desktop.scrolling_up": "Scrolling up",
  "desktop.scrolling_down": "Scrolling down",
  "desktop.scrolling_left": "Scrolling left",
  "desktop.scrolling_right": "Scrolling right",
  "desktop.step": "{label}",
  "desktop.pointing_at": "Pointing at {name}",
  "desktop.pointing_on_screen": "Pointing on screen",
  "desktop.highlighting_named": "Highlighting {name}",
  "desktop.highlighting_on_screen": "Highlighting on screen",
  "desktop.marking_named": "Marking {name}",
  "desktop.drawing_on_screen": "Drawing on screen",
  "desktop.showing_named": "Showing {name}",
  "desktop.showing_frames": "Showing frames",
  "desktop.checking_progress": "Checking progress",
  "desktop.waiting_for_playback": "Waiting for playback",
  "desktop.resuming": "Resuming",
  "desktop.filling_named": "Filling {target}",
  "desktop.filling_fields": {
    one: "Filling {count} field",
    other: "Filling {count} fields",
  },
  "desktop.replacing_text_named": "Replacing text in {target}",
  "desktop.replacing_text_fields": {
    one: "Replacing text in {count} field",
    other: "Replacing text in {count} fields",
  },
  "desktop.pressing_controls": {
    one: "Pressing {count} control",
    other: "Pressing {count} controls",
  },
  "desktop.pressing_keys": {
    one: "Pressing {count} key",
    other: "Pressing {count} keys",
  },
  "desktop.reading_named": "Reading {target}",
  "desktop.reading_controls": {
    one: "Reading {count} control",
    other: "Reading {count} controls",
  },
  "desktop.choosing_named": "Choosing {target}",
  "desktop.choosing_commands": {
    one: "Choosing {count} menu command",
    other: "Choosing {count} menu commands",
  },
  "desktop.checking_named": "Checking {target}",
  "desktop.checking_boxes": {
    one: "Checking {count} box",
    other: "Checking {count} boxes",
  },
  "desktop.unchecking_named": "Unchecking {target}",
  "desktop.unchecking_boxes": {
    one: "Unchecking {count} box",
    other: "Unchecking {count} boxes",
  },
  "desktop.dragging_named": "Dragging {target}",
  "desktop.dragging_items": {
    one: "Dragging {count} item",
    other: "Dragging {count} items",
  },
  "desktop.dragging_to": "{item} to {target}",
  "desktop.adding_files_named": "Adding files to {target}",
  "desktop.adding_files_fields": {
    one: "Adding files to {count} field",
    other: "Adding files to {count} fields",
  },
  "desktop.downloading_named": "Downloading {target}",
  "desktop.downloading_files": {
    one: "Downloading {count} file",
    other: "Downloading {count} files",
  },
  "desktop.waiting_for_named": "Waiting for {target}",
  "desktop.waiting_for_text": "Waiting for text",
  "desktop.waiting": "Waiting",
  "desktop.key_repeat": "{key} ×{repeat}",
  "desktop.then": "{first}, then {next|lower}",
  "desktop.then_parts": "{first}, {rest|lower}",
  "desktop.more": "{label} +{count} more",
  "desktop.in_background": "{action} in the background",
} as const;
